import { render, staticRenderFns } from "./tariff-popup.vue?vue&type=template&id=3548def6&scoped=true&"
import script from "./tariff-popup.vue?vue&type=script&lang=ts&"
export * from "./tariff-popup.vue?vue&type=script&lang=ts&"
import style0 from "./tariff-popup.vue?vue&type=style&index=0&id=3548def6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548def6",
  null
  
)

export default component.exports